import { useCallback } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

import type { ComponentProps } from "react";

type Props = {
	onUpdate: () => Promise<void>;
	isValid: boolean;
};

export const SettingsSiteControllerHeader = ({ onUpdate, isValid }: Props) => {
	const variant: ComponentProps<typeof Button>["variant"] = isValid ? "default" : "disabled";

	const handleClick = useCallback(async () => {
		await onUpdate();
	}, [onUpdate]);

	return (
		<FeatureIslandHeader
			title="サイコンの設定"
			rightChildren={
				<Button variant={variant} type="button" size="xl" onClick={handleClick}>
					保存
				</Button>
			}
		/>
	);
};

SettingsSiteControllerHeader.displayName = "SettingsSiteControllerHeader";
